import {useGrpcRequest} from '@aboutyou/data-fetcher';
// eslint-disable-next-line jest/no-mocks-import
import {StoryPageService_GetPageNextLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/story_page/v1/service.grpc.lazy';
import {useResetOnFetchEnd} from '../../../../features/ProductStream/utils';
import {
  useStoryPageRequestParams,
  useWithNextState,
} from './useStoryPageStream';

export const useStoryPageStreamNext = ({token}: {token: string}) => {
  const {
    params: {session, reductionsState, preferredProductImageType},
    disabled,
    keepPreviousData,
    resetOnFetchEnd,
  } = useStoryPageRequestParams();

  const request = useGrpcRequest(
    StoryPageService_GetPageNextLazy,
    {
      session,
      reductionsState,
      preferredProductImageType,
      continuationToken: token,
    },
    {
      disabled,
      keepPreviousData,
      retry: 1,
      mockData: async params =>
        import('./__mocks__/getStoryPageMock').then(module =>
          module.getStoryPageMock(params),
        ),
    },
  );

  useResetOnFetchEnd(request, resetOnFetchEnd);

  return useWithNextState(request);
};
